import { render, staticRenderFns } from "./EbookFeature.vue?vue&type=template&id=77022288&"
import script from "./EbookFeature.vue?vue&type=script&lang=js&"
export * from "./EbookFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports